module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_8019.2db9523e.png";